<template>
    <div v-if="!loading && loaded" class="grade_item-container">
        <h2 class="grade_item-name">Диаграмма успешности прохождения заданий</h2>
        <div class="chart">
            <apexchart type="pie" height="467" :options="options" :series="series"></apexchart>
        </div>
    </div>
</template>

<script>
import apexchart from 'vue-apexcharts';

export default {
    name: 'ResultsByScore',
    components: { apexchart },
    props: {
        loading: Boolean
    },
    data: () => ({
        options: {
            dataLabels: {
                enabled: false
            },
            legend: {
                position: 'bottom'
            },
            colors: [ '#33A56E', '#21B8DA', '#EEC840', '#EE4040' ],
            chart: {
                width: 380,
                type: 'pie'
            },
            labels: [ 'Отлично', 'Хорошо', 'Удовлетворительно', 'Плохо' ],
            responsive: [{
                breakpoint: 480,
                options: {
                    chart: {
                        width: 200
                    }
                }
            }],
        },
        series: [],
        loaded: false
    }),
    methods: {
        update(data) {
            data.sort((a, b) => this.options.labels.indexOf(a.name) - this.options.labels.indexOf(b.name));
            this.series = data.map(x => x.percent);
            this.loaded = true;
        }
    }
}
</script>
